import { lazy } from 'react'

export const ResourcesRoutes = [
     // {
    //     path: '/resources/site-structures/list',
    //     component: lazy(() => import('../views/structures-list')),
    //     meta: {
    //         action: 'call',
    //         resource: "RES_MANAGE_SITES"
    //     }
    // },
    // {
    //     path: '/resources/sites-old/list',
    //     component: lazy(() => import('../views/sites-list')),
    //     meta: {
    //         action: 'call',
    //         resource: "RES_MANAGE_SITES"
    //     }
    // },
    // {
    //     path: '/resources/sites/list/new',
    //     component: lazy(() => import('../views/sites-list-new/new-index')),
    //     meta: {
    //         action: 'call',
    //         resource: "RES_MANAGE_SITES"
    //     }
    // },
    // {
    //     path: '/resources/sites/list',
    //     component: lazy(() => import('../views/sites-list-new')),
    //     meta: {
    //         action: 'call',
    //         resource: "RES_MANAGE_SITES"
    //     }
    // },
    {
        path: '/resources/global-lists',
        component: lazy(() => import('../views/global-lists')),
        exact: true,
        meta: {
            action: 'call',
            resource: "RES_MANAGE_GLOBAL_LISTS|RES_VIEW_GLOBAL_LISTS"
        }
    },
    {
        path: '/resources/global-lists/archive',
        component: lazy(() => import('../views/global-lists-archive')),
        exact: true,
        meta: {
            action: 'call',
            resource: "RES_MANAGE_GLOBAL_LISTS"
        }
    },
    {
        path: '/resources/global-lists/:uuid',
        component: lazy(() => import('../views/global-lists-manage')),
        exact: true,
        meta: {
            action: 'call',
            resource: "RES_MANAGE_GLOBAL_LISTS",
            general: true
        }
    },
    {
        path: '/resources/global-lists/:uuid/items',
        component: lazy(() => import('../views/global-lists-items')),
        exact: true,
        meta: {
            action: 'call',
            resource: "RES_MANAGE_GLOBAL_LISTS|RES_VIEW_GLOBAL_LISTS",
            general: true
        }
    },
    {
        path: '/resources/global-lists/:uuid/items/archive',
        component: lazy(() => import('../views/global-lists-items-archive')),
        exact: true,
        meta: {
            action: 'call',
            resource: "RES_MANAGE_GLOBAL_LISTS",
            general: true
        }
    },
    {
        path: '/resources/filemanager',
        component: lazy(() => import('../views/filemanager')),
        meta: {
            action: 'call',
            resource: "RES_MANAGE_FILE_MANAGER"
        }
    }
]

